const initialState = {
  sendMailPending: false,
  sendMailError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/home/redux/initialState.js